/**
 * Controller used for mobile policies screens
 */
bookingApp.controller('policyController', function($scope){
    //$scope.baseApp.controls.type = 'back';
    $scope.footer.display = {prev: false, main: true, next: false};
    $scope.footer.mainContent = '<span class="glyphicon glyphicon-chevron-left"></span> Back';
    $scope.footer.mainFunc = function(){
        $scope.goBack();
    };
});
